import validate from "/usr/src/app/content/n3-packages-23cc7ac8-f179-42ba-8ecf-6700c0674db6/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-packages-23cc7ac8-f179-42ba-8ecf-6700c0674db6/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}